module.exports = __webpack_public_path__ + "img/l_sk.c199fbc6.png";